import { atom } from "jotai";

export const HelpSearchAtom = atom<string>("");
